module.exports = __webpack_public_path__ + "img/1.e3f728f0.jpg";